import React from "react";
import { Check, X } from "lucide-react";
import { Section, Eyebrow, Reveal } from "./shared";
import { TRANSFORM } from "../../lib/site";

export default function Transformation() {
  return (
    <Section id="transformation" bg="bg-brand-black" dark>
      <Reveal className="max-w-3xl">
        <Eyebrow color="#FFCB52" dark>The Shift</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5 text-brand-cream">
          You Have the Knowledge. What You Need Is <span className="text-brand-yellow">Direction, a System, and Accountability.</span>
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-6 mt-12 items-start">
        {/* Before */}
        <Reveal>
          <div className="rounded-[28px] border-2 border-brand-cream/20 bg-brand-cream/[0.04] p-7 sm:p-9">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-red">Where You May Be Today</p>
            <ul className="mt-5 space-y-3">
              {TRANSFORM.before.map((b) => (
                <li key={b} className="flex items-start gap-3 text-brand-cream/70">
                  <span className="mt-0.5 h-5 w-5 rounded-full bg-brand-red/20 flex items-center justify-center shrink-0"><X size={13} className="text-brand-red" /></span>
                  <span className="text-sm sm:text-base line-through decoration-brand-cream/25">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        {/* After */}
        <Reveal delay={0.1}>
          <div className="rounded-[28px] border-2 border-brand-green bg-brand-green/10 p-7 sm:p-9"
            style={{ boxShadow: "10px 12px 0 #4CAF48" }}>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-green">What You Will Work Toward Building</p>
            <ul className="mt-5 space-y-3">
              {TRANSFORM.after.map((a) => (
                <li key={a} className="flex items-start gap-3 text-brand-cream">
                  <span className="mt-0.5 h-5 w-5 rounded-full bg-brand-green flex items-center justify-center shrink-0"><Check size={13} className="text-white" /></span>
                  <span className="text-sm sm:text-base font-medium">{a}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
